import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Button, Card, Container, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import "../css/VerifyOtp.css";

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const phone = location.state?.phone || "";

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const otpCode = otp.join("");

  const handleVerify = async (e) => {
    e.preventDefault();

    if (otpCode.length < 4) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete OTP",
        text: "Please enter the 4-digit OTP code.",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_APP_URL}/verify-phone`,
        {
          phone_number: phone,
          otp: otpCode,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Verification Successful",
        text: res.data.message,
        timer: 2000,
      }).then(() => navigate("/login"));
    } catch (err) {
      const msg = err.response?.data?.message || "Verification failed.";
      Swal.fire({ icon: "error", title: "Failed", text: msg });
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_APP_URL}/resend-otp`,
        { phone_number: phone },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
        }
      );

      Swal.fire({
        icon: "info",
        title: "OTP Sent",
        text: res.data.message,
      });
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to resend OTP.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card
        className="p-4 shadow-lg"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <h4 className="text-center mb-3">Verify WhatsApp</h4>
        <p className="text-center text-muted">
          Enter the 4-digit code sent to <strong>{phone}</strong>
        </p>

        <Form onSubmit={handleVerify}>
          <Row className="justify-content-center mb-3">
            {otp.map((digit, index) => (
              <Col key={index} xs={3} className="px-1">
                <Form.Control
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputRefs.current[index] = el)}
                  className="text-center otp-input"
                  required
                />
              </Col>
            ))}
          </Row>

          <Button type="submit" variant="primary" className="w-100 mb-2">
            {loading ? "Verifying..." : "Verify OTP"}
          </Button>

          <Button
            variant="outline-secondary"
            className="w-100"
            type="button"
            onClick={handleResend}
          >
            Resend OTP
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default VerifyOtp;
